// ========== 首页店铺筛选相关 getters ==========

// 获取选中的门店列表（扁平化，包含完整门店信息）
export function selectedShopList(state) {
  const result = []
  const selectedBrandIds = state.brandShopFilter.selectedBrandIds

  // 遍历选中的品牌，收集门店
  selectedBrandIds.forEach(brandId => {
    const shopIds = state.brandShopFilter.selectedShopMap[brandId] || []
    const brand = state.brandShopFilter.brandShopMap[brandId]
    if (brand) {
      shopIds.forEach(shopId => {
        const shop = brand.shopList.find(s => s.shopId === shopId)
        if (shop) {
          result.push({ brandId, shopId, shopName: shop.shopName })
        }
      })
    }
  })

  return result
}

// 获取品牌列表（用于品牌选择页）
export function brandList(state) {
  return state.brandShopFilter.brandShopOptions.map(brand => ({
    brandId: brand.brandId,
    brandName: brand.brandName,
    shopList: brand.shopList,
    shopCount: brand.shopList.length,
  }))
}

// 获取某个品牌下的门店列表
export function getShopsByBrandId(state) {
  return brandId => {
    const brand = state.brandShopFilter.brandShopMap[brandId]
    return brand ? brand.shopList : []
  }
}

// 判断某个品牌的门店是否全选
export function isAllShopsSelectedByBrand(state) {
  return brandId => {
    const brand = state.brandShopFilter.brandShopMap[brandId]
    if (!brand || brand.shopList.length === 0) return false

    const selectedShops = state.brandShopFilter.selectedShopMap[brandId] || []
    return brand.shopList.length === selectedShops.length
  }
}

// 是否选择了"所有品牌"选项（selectedBrandIds 包含的品牌超过一个）
export function isMultiBrandMode(state) {
  const { selectedBrandIds } = state.brandShopFilter
  return selectedBrandIds.length > 1
}

// 获取某品牌的半选状态（部分门店被选中）
export function isIndeterminateByBrand(state) {
  return brandId => {
    const brand = state.brandShopFilter.brandShopMap[brandId]
    if (!brand || brand.shopList.length === 0) return false

    const selectedShops = state.brandShopFilter.selectedShopMap[brandId] || []
    return selectedShops.length > 0 && selectedShops.length < brand.shopList.length
  }
}

// 判断某品牌是否有选中门店
export function isBrandHasSelection(state) {
  return brandId => {
    const selectedShops = state.brandShopFilter.selectedShopMap[brandId] || []
    return selectedShops.length > 0
  }
}

// 获取选中门店的总数
export function totalSelectedShopsCount(state) {
  let count = 0
  Object.values(state.brandShopFilter.selectedShopMap).forEach(shopIds => {
    count += shopIds.length
  })
  return count
}
